define('viewModels/privileged/qm/policies/editors/DateEditorView',[
    'lib/knockout',
    'moment',
    'util/dateTimeConstant',
    'viewModels/ViewModel',

    // No references
    'extensions/i18n/knockout.i18n'
], function (ko, moment, dateTimeConstant, ViewModel) {
    'use strict';

    /**
     * The DateEditorView class.
     * @class
     */
    var DateEditorView = ViewModel.extend(function (dateValue) {
        var self = this;
        self.dateValue = ko.observable();
        self.dateText = ko.observable();
        self.isOpen = ko.observable(false);
        self.placeHolderText = ko.observable();
        self.hasChanged = ko.observable(false);

        var updateDateValues = function(dateValue) {
            var dateText = ko.i18n.renderString('widget.datePicker.format', {
                date: dateValue
            });
            self.dateText(ko.i18n.formatDate(new Date(dateText)));
        };

        if (ko.isObservable(dateValue)) {
            self.dateValue = dateValue;
        } else if (dateValue) {
            self.dateValue(dateValue);
        } else {
            var todayStart = moment().startOf('day').toDate();
            self.dateValue(todayStart.toISOString());
        }

        self.computed(function () {
            updateDateValues(self.dateValue());
            if(ko.unwrap(dateValue) !== self.dateValue()){
                self.hasChanged(true);
            }
        });
    });

    return DateEditorView;
});

